<template>
  <el-table-column v-if="column.child && column.child.length" :label="column.label">
    <dg-table-column :key="column.prop" :column="column.child" :align="column.align || align"></dg-table-column>
  </el-table-column>
  <el-table-column :prop="column.prop" :width="column.width" :label="column.label" :fixed="column.fixed"
    :sortable="column.sortable" :min-width="column.minWidth" :align="column.align || align"
    :show-overflow-tooltip="true" :render-header="column.renderHeader" v-else>
    <template slot="header" slot-scope="scope">
      <div class="flex items-center" v-if="column.header">
        <dg-search-header v-if="column.url && column.options" keys="key" :label="column.label" :url="column.url"
          :propOptions="column.options || []" @checked="(obj) => handleSearchStatus(obj)" :params="column.params"
          :isMultiple="column.isMultiple" :currentKey="column.currentKey" :noAjax="column.noAjax"></dg-search-header>
      </div>
      <span v-else-if="column.sortable">{{ getOrderArrayIndex(column) ? `${column.label}${getOrderArrayIndex(column)}` :
        column.label }}</span>
      <span v-else>{{ column.label }}</span>
    </template>
    <template slot="default" slot-scope="scope">
      <slot v-if="column.slotProp" :name="column.slotProp" v-bind="scope"></slot>
      <template v-else>
        <div class="flex items-center flex-nowrap" v-if="column.copy">
          <i class="el-icon-document-copy copy-icon cursor-pointer" v-if="column.copy && scope.row[column.prop]"
            v-copy="scope.row[column.prop]"></i>
          <div class="aui-ellipsis-1 ml-[6]">
            {{ scope.row[column.prop] || column.default }}
          </div>
        </div>
        <div v-else class="aui-ellipsis-1">
          {{ scope.row[column.prop] || column.default }}
        </div>
      </template>
    </template>
  </el-table-column>
</template>

<script>
import DgSearchHeader from "./dg-search-header.vue";
export default {
  name: 'DgTableColumn',
  props: {
    column: {
      type: Object,
      default: () => { }
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  directives: {
    copy: {
      // 指令的定义
      bind: function (el, binding) {
        el.$value = binding.value;
        if (!el.$value) {
          // 值为空的时候，给出提示
          this.$message.warning('暂无内容');
          return;
        }
        el.handler = () => {
          el.style.position = 'relative';
          // 动态创建 textarea 标签
          const textarea = document.createElement('textarea');
          // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
          textarea.readOnly = 'readonly';
          textarea.style.position = 'absolute';
          textarea.style.top = '0px';
          textarea.style.left = '-9999px';
          textarea.style.zIndex = '-9999';
          // 将要 copy 的值赋给 textarea 标签的 value 属性
          textarea.value = el.$value;
          // 将 textarea 插入到 el 中
          el.appendChild(textarea);
          // 兼容IOS 没有 select() 方法
          if (textarea.createTextRange) {
            textarea.select(); // 选中值并复制
          } else {
            textarea.setSelectionRange(0, el.$value.length);
            textarea.focus();
          }
          const result = document.execCommand('Copy');
          if (result) this.$message.success('复制成功');
          el.removeChild(textarea);
        };
        el.addEventListener('click', el.handler); // 绑定点击事件
      },
      // 当传进来的值更新的时候触发
      componentUpdated(el, binding) {
        el.$value = binding.value;
      },
      // 指令与元素解绑的时候，移除事件绑定
      unbind(el) {
        el.removeEventListener('click', el.handler);
      }
    }
  },
  components: {
    DgSearchHeader,
  },
  data() {
    return {
      orderArray: [],
    }
  },
  methods: {
    handleSearchStatus(obj) {
      this.$emit("handleSearchHeader", obj);
    },
    getOrderArrayIndex(column) {
      const index = this.orderArray.findIndex(item => item.sortField === column.prop)
      return index > -1 ? (index + 1) : 0;
    }
  },
  // beforeUpdate() {
  //   console.log('dg-table-column beforeUpdate');
  //   console.log('beforeUpdate-column', this.column);
  // },
  // updated() {
  //   console.log('dg-table-column updated');
  //   console.log('updated-column', this.column);
  // },
  // created() {
  //   console.log('dg-table-column created');
  //   console.log('created-column', this.column);
  // },
  mounted() {
    this.$bus.$on('handleSortHeaderNum', (orderArray) => {
      this.orderArray = orderArray || [];
    });
  },
}
</script>

<style lang="less" scoped></style>